import React from "react";
import { Link } from "react-router-dom";

/** Branded 404 page. */
export default function NotFound() {
  return (
    <div className="bg-[#141414] texture-dark min-h-screen flex items-center justify-center px-6 py-32" data-testid="not-found-page">
      <div className="text-center">
        <p className="kicker text-white/40 mb-6">Lost in the edit</p>
        <h1
          className="font-serif-display text-white leading-none"
          style={{ fontSize: "clamp(100px, 20vw, 240px)" }}
          data-testid="not-found-heading"
        >
          404
        </h1>
        <p className="font-comfortaa text-white/70 text-sm md:text-base mt-8 max-w-md mx-auto leading-relaxed">
          This scene didn't make the final cut. The page you're looking for
          doesn't exist or has been moved.
        </p>
        <Link to="/" className="pill-button inline-block mt-12" data-testid="not-found-home-button">
          Back to the studio
        </Link>
      </div>
    </div>
  );
}
